export const fmt = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    n || 0,
  );

export const formatFileName = (name, maxLength = 40) => {
  return name.length > maxLength ? name.slice(0, maxLength - 3) + "..." : name;
};

/**
 * Return today's date as YYYY-MM-DD in the local timezone.
 * Avoids `new Date().toISOString().slice(0,10)` which returns UTC
 * and shows the next day for US users after ~7pm ET.
 */
export const localToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

/**
 * Parse a date-only string (e.g. "2026-10-20") in local timezone.
 * new Date("2026-10-20") parses as midnight UTC, which displays as
 * the previous day for US timezones. Appending T12:00:00 forces
 * noon local interpretation, avoiding the off-by-one.
 */
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  // Already has time component — parse as-is
  if (dateStr.includes("T") || dateStr.includes(" ")) return new Date(dateStr);
  return new Date(dateStr + "T12:00:00");
};
